import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const DashboardOpportunityReportConfig: ReportConfigBase = {
  type: EReportTypes.DashboardOpportunity,
  endpoint: "order",
  reportKey: "orders",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Dashboard Opportunity Report provides detailed information about a rep's opportunities",
    url: "https://help.commonsku.com/knowledge/sales-dashboard-report",
  },
};

export default DashboardOpportunityReportConfig;
